import { render } from "./Security.vue?vue&type=template&id=dfef011e"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/admin/Security.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dfef011e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dfef011e', __exports__)) {
    api.reload('dfef011e', __exports__)
  }
  
  module.hot.accept("./Security.vue?vue&type=template&id=dfef011e", () => {
    api.rerender('dfef011e', render)
  })

}


export default __exports__